<template lang="pug">
  v-layout.box-beneficios-desbloqueados-formatter
    PopupAlertMessage(
      @closeAlertPopup="actionPopupMethod($event, popupAlert.option)"
      :openPopup="popupAlert.openPopup"
      :image="popupAlert.image"
      :title="popupAlert.title"
      :message="popupAlert.message"
      :messageButton="popupAlert.messageButton"
      :buttonClose="popupAlert.buttonClose"
      :imgHeight="popupAlert.imgHeight"
      :imgWidth="popupAlert.imgWidth"
    )
    //- LOADER PROCESS
    v-dialog(v-model="loader.flag" persistent width="300")
      v-card(color="primary" dark)
        v-card-text
          | {{loader.text}}
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- DIALOG ENDORSEMENT RELEASE
    v-dialog(v-model="dialogEndorsementRelease" width="450" :persistent="true")
      v-card#info-endorsement-release
        v-card-title(style="padding-bottom: 0;")
          v-layout(wrap)
            v-flex.text-xs-center
              img(:src='endorsementReleaseInfo.logo' width="120px" style="align-self: center;")
        v-card-title(style="padding-bottom: 0; padding-top: 0;")
          v-flex(style="justify-content: center;")
            h1.omnesMedium(style="color: #0855c4; text-align: center; font-size: 18px;") ¿Qué es liberación de endoso?
            v-flex
              p.omnesRegular.info--text.text-xs-center(style="margin-left: 15px; margin-right: 10px;") Es la acción de dejar sin efecto los beneficios de la póliza dadas a un tercero, en este caso a la entidad financiera.
        v-card-title(style="padding-bottom: 0; padding-top: 0;")
          v-flex
            h2.omnesMedium.text-xs-center(style="color: #0855c4; font-size: 18px;") ¿Cómo funciona?
        v-card-text(style="padding-bottom: 0; padding-top: 0;")
          v-layout(wrap)
            v-flex(xs12 sm12 md12 lg12)
              v-layout(wrap style="margin-bottom: 0;")
                v-flex.text-xs-center(xs3 sm2 md2 lg2 style="margin-left: 3%;")
                  img.mt-2(:src='endorsementReleaseInfo.bullet1' width="60px" style="align-self: center;")
                v-flex(xs8 sm9 md9 lg9 style="align-self: center;")
                  p.omnesRegular.info--text.mb-2.mt-2(style="margin-left: 10px;") Adjunta la carta de no adeudo emitida por la entidad financiera o EECC donde figura el pago del seguro de desgravamen.
            v-flex(xs12 sm12 md12 lg12)
              v-layout(wrap style="margin-bottom: 0;")
                v-flex.text-xs-center(xs3 sm2 md2 lg2 style="margin-left: 3%;")
                  img.mt-2(:src='endorsementReleaseInfo.bullet2' width="60px" style="align-self: center;")
                v-flex(xs8 sm9 md9 lg9 style="align-self: center;")
                  p.omnesRegular.info--text.mb-2.mt-2(style="margin-left: 10px;") Envía tu solicitud y te responderemos en 48 horas.
          v-card-actions(wrap style="margin-top: 0;")
            v-layout
              v-flex.text-xs-center
                v-btn#btn-endorsements(color="dark" @click="actionPopupMethod(true, 'comodin')") ¡Estoy listo!
    v-layout(column)
      v-flex(style="line-height:normal;margin:0.5em 0em")
        span(style="font-size: 15px;color: #454A6C;") ¡Lo lograste! Desbloqueaste estos beneficios de tu producto.
      v-flex
        v-layout( column  align-center )
          v-flex(v-if="puedeCambiarBeneficiario" style="margin: 0.8em 0em")
            TarjetaBeneficiosDesbloqueado2(
              @linkMethod="actionMethod"
              :mensajeBanda="'Desbloqueado'"
              :icon="iconBeneficio1"
              :titulo="'Modificación de Beneficiarios'"
              :descripcion="'Ahora puedes modificar, agregar y eliminar beneficiarios '"
              :mensajeBoton="'1er año'"
              :link="'Ingresa aquí.'"
              :opcion="'modificar beneficiario'"
              )
          v-flex(style="margin: 0.8em 0em")
            TarjetaBeneficiosDesbloqueado2(
              @linkMethod="actionMethod"
              :mensajeBanda="'Desbloqueado'"
              :icon="iconBeneficio2"
              :titulo="'Programa Vive +'"
              :descripcion="'Ahora puedes acceder a tus Descuentos y Asistencias desde tu Zona Segura '"
              :mensajeBoton="'1er año'"
              :link="'Ingresa aquí.'"
              :opcion="'vivemas'"
              )
          v-flex(v-if="puedeEndosar" style="margin: 0.8em 0em")
            TarjetaBeneficiosDesbloqueado2(
              @linkMethod="actionMethod"
              :mensajeBanda="'Desbloqueado'"
              :icon="iconBeneficio3"
              :titulo="'Endoso'"
              :descripcion="'Desbloqueaste este  beneficio,  puedes endosar tu póliza con un seguro de desgravamen o crédito hipotecario '"
              :mensajeBoton="'1er año'"
              :link="'Ingresa aquí.'"
              :opcion="'endoso'"
              )
          v-flex(style="margin: 0.8em 0em")
            TarjetaBeneficiosDesbloqueado2(
              @linkMethod="actionMethod"
              :mensajeBanda="'Desbloqueado'"
              :icon="iconBeneficio4"
              :titulo="'Contrata más coberturas'"
              :descripcion="'Ya puedes contratar más coberturas para tu seguro contacta a tu asesor o '"
              :mensajeBoton="'1er año'"
              :link="'Ingresa aquí.'"
              :opcion="'cda'"
              )
          v-flex(v-if="flagMas2Anhos && tieneCuotaComodin" style="margin: 0.8em 0em")
            TarjetaBeneficiosDesbloqueado2(
              @linkMethod="actionMethod"
              :mensajeBanda="'Desbloqueado'"
              :icon="iconBeneficio7"
              :titulo="'Cuota comodín'"
              :descripcion="'Podrás dejar de pagar una cuota y no preocuparte por el pago hasta el siguiente mes '"
              :mensajeBoton="'2do año'"
              :link="'Ingresa aquí.'"
              :opcion="'comodin'"
              )
          v-flex(v-if="flagMas2Anhos && poliza.nombreProducto === 'VIDAFREE'" style="margin: 0.8em 0em; display: none;")
            TarjetaBeneficiosDesbloqueado2(
              @linkMethod="actionMethod"
              :mensajeBanda="'Desbloqueado'"
              :icon="iconBeneficio5"
              :titulo="'Extender fin de vigencia'"
              :descripcion="'Para solicitar este beneficio conoce nuestros canales ingresando '"
              :mensajeBoton="'2do año'"
              :link="'aquí.'"
              :opcion="'cda'"
              )
          v-flex(v-if="flagMas2Anhos && poliza.nombreProducto != 'VIDAFREE'" style="margin: 0.8em 0em")
            TarjetaBeneficiosDesbloqueado2(
              @linkMethod="actionMethod"
              :mensajeBanda="'Desbloqueado'"
              :icon="iconBeneficio6"
              :titulo="'Préstamo'"
              :descripcion="'Para solicitar tu préstamo  conoce nuestros canales ingresando '"
              :mensajeBoton="'2do año'"
              :link="'aquí.'"
              :opcion="'cda'"
              )
      //-v-flex(style="width: 25.5em;margin: 0em auto 3em auto;")
        v-layout( row justify-center)
          v-flex(xs1 mr-0)
            img(:src="iconAlerta")
          v-flex
            span(style="font-size: 14px;color: #919191;") Recuerda que los beneficios que no encuentres en Zona Segura podrás solicitarlo desde el
              b
                a(
                  style="color: #454A6C;"
                  :href="links.Chat" target="_blank"
                  ) Chat Interseguro.
      v-flex.box-desplegar(
        v-if="!flagMas2Anhos"
        style="text-align: center;")
        v-layout(column)
          v-flex
            span(style="font-size: 18px;color: #454A6C;") ¡Te falta poco, en 2 años podrás desbloquear estos beneficios!
          v-flex
            v-img
              img(
                :class="{'desplegado': desplegarBloqueados,'bloqueado': !desplegarBloqueados}"
                @click="desplegarBloqueadosMethod"
                :src="iconDesplegar"
                )
          v-flex(v-if="desplegarBloqueados")
            v-layout(column)
              v-flex(v-if="tieneCuotaComodin" style="margin: 0.8em 0em")
                TarjetaBeneficioBloqueado(
                  :mensajeBanda="'2do año bloqueado'"
                  :titulo="'Cuota comodín'"
                  :descripcion="'Podrás dejar de pagar una cuota y no preocuparte por el pago hasta el siguiente mes.'"
                  )
              v-flex(v-if="poliza.nombreProducto === 'VIDAFREE'" style="margin: 0.8em 0em; display: none;")
                TarjetaBeneficioBloqueado(
                  :mensajeBanda="'2do año bloqueado'"
                  :titulo="'Extender fin de vigencia'"
                  :descripcion="'Ahora puedes extender la vigencia de tu seguro.'"
                  )
              v-flex(style="margin: 0.8em 0em")
                TarjetaBeneficioBloqueado(
                  v-if="poliza.nombreProducto != 'VIDAFREE'"
                  :mensajeBanda="'2do año bloqueado'"
                  :titulo="'Préstamo'"
                  :descripcion="'Ahora puedes solicitar tu préstamo.'"
                  )

</template>

<script>
import TarjetaBeneficiosDesbloqueado2 from '../generic/TarjetaBeneficiosDesbloqueado2.vue'
import TarjetaBeneficioBloqueado from './TarjetaBeneficioBloqueado.vue'
import PopupAlertMessage from '../PopupAlertMessage.vue'
import {mapActions, mapGetters} from 'vuex'
import Links from '../../interfaces/links'
import Functionalities from '../../interfaces/functionalities'

export default {
  props: [
    'mas2Anhos',
    'poliza',
    'solicitudBeneficiarios',
    'solicitudComodin',
    'solicitudEndosoEntidadFinanciera',
    'solicitudLiberacionEndoso',
    'solicitudAnulacion',
    'solicitudSeguimiento',
    'puedeEndosar',
    'puedeCuotaComodin',
    'tieneCuotaComodin',
    'puedeCambiarFrecuencia',
    'puedeLiberarEndoso',
    'puedeCambiarBeneficiario',
    'taggeo'
  ],
  data () {
    return {
      links: Links,
      iconBeneficio1: require('./../../assets/icons-mis-seguros/icon-beneficios-desbloqueado1.svg'),
      iconBeneficio2: require('./../../assets/icons-mis-seguros/icon-beneficios-desbloqueado2.svg'),
      iconBeneficio3: require('./../../assets/icons-mis-seguros/icon-beneficios-desbloqueado3.svg'),
      iconBeneficio4: require('./../../assets/icons-mis-seguros/icon-beneficios-desbloqueado4.svg'),
      iconBeneficio5: require('./../../assets/icons-mis-seguros/icon-beneficios-desbloqueado5.svg'),
      iconBeneficio6: require('./../../assets/icons-mis-seguros/icon-beneficios-desbloqueado6.svg'),
      iconBeneficio7: require('./../../assets/icons-mis-seguros/icon-beneficios-desbloqueado7.svg'),
      iconDesplegar: require('./../../assets/icons/icon-doble-flag.svg'),
      iconAlerta: require('./../../assets/iconsv5/icon-alert.svg'),
      desplegarBloqueados: false,
      loader: {
        flag: false,
        text: 'Redireccionando...'
      },
      popupAlert: {
        openPopup: false,
        option: '',
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      },
      flagMas2Anhos: this.mas2Anhos || false,
      mensaje1: 'Te redireccionaremos a la solicitud ',
      mensaje2: 'En estos momentos no puede realizar esta solicitud',
      mensaje3: 'Está solicitud no está disponible para ti, revisa las condiciones de tu seguro.',
      dialogEndorsementRelease: false,
      endorsementReleaseInfo: {
        logo: require('./../../assets/general/personaje_computador_2.svg'),
        bullet1: require('./../../assets/general/nube_check.svg'),
        bullet2: require('./../../assets/general/tiempo_48h.svg')
      },
      metadata: {}
    }
  },
  computed: {
    ...mapGetters('user', ['functionsRules'])
  },
  mounted () {
    let self = this
    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Beneficios desbloqueados', metadata: self.metadata})

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'mobile',
        'seccion': 'beneficios desbloqueados'
      }
    })
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    methodClosePopup () {
      this.$emit('closePopup')
    },
    actionMethod (option) {
      const self = this
      let auxSolicitud
      switch (option) {
      case 'modificar beneficiario':
        if (!Functionalities.isAvailable(Functionalities.vida.VIMDB, self.functionsRules, self)) {
          return
        }
        this.popupAlert.openPopup = true
        this.popupAlert.messageButton = 'Entendido'
        this.popupAlert.buttonClose = this.puedeCambiarBeneficiario

        auxSolicitud = this.solicitudBeneficiarios.pop()

        if (this.puedeCambiarBeneficiario) {
          if (!auxSolicitud || auxSolicitud.state === 'ERROR' || auxSolicitud.state === 'ATENDIDO' ||
              auxSolicitud.state === 'PROCESADO' || auxSolicitud.state === 'PROCESADO RPA' ||
              auxSolicitud.state === 'CONFORME' || auxSolicitud.state === 'RECHAZADO') {
            this.popupAlert.message = this.mensaje1 + 'Modificación de Beneficiarios...'
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.option = 'beneficiarios'
          }
          if (auxSolicitud && auxSolicitud.state === 'PENDIENTE') {
            this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
            this.popupAlert.message = 'Podrás modificar tus beneficiarios luego de que tu solicitud sea aprobada.'
          }
        } else {
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = this.mensaje2
          this.popupAlert.option = ''
        }
        break
      case 'vivemas':
        this.$router.push({ path: '/vivemas' })
          .then(res => {
          }).catch(() => {
            this.popupAlert.openPopup = true
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.message = 'Tenemos algunos inconvenientes para cargar la opción. Vuelva a intentarlo en unos minutos.'
            this.popupAlert.messageButton = 'Entendido'
            this.popupAlert.buttonClose = false
          })
        break
      case 'endoso':
        if (!Functionalities.isAvailable(Functionalities.vida.VIEEF, self.functionsRules, self)) {
          return
        }
        this.popupAlert.openPopup = true
        this.popupAlert.messageButton = 'Entendido'
        this.popupAlert.buttonClose = this.puedeEndosar

        auxSolicitud = this.solicitudEndosoEntidadFinanciera.pop()

        if (this.puedeEndosar) {
          if (!auxSolicitud || (auxSolicitud && (auxSolicitud.state === 'ERROR' || auxSolicitud.state === 'ATENDIDO' ||
              auxSolicitud.state === 'PROCESADO' || auxSolicitud.state === 'PROCESADO RPA' ||
              auxSolicitud.state === 'CONFORME' || auxSolicitud.state === 'RECHAZADO'))) {
            this.popupAlert.message = this.mensaje1 + 'Endoso a entidad financiera...'
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.option = 'endoso'
          }
          if (auxSolicitud && auxSolicitud.state === 'PENDIENTE') {
            this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
            this.popupAlert.message = 'Podrás endosar a una entidad financiera luego de que tu solicitud sea aprobada.'
          }
        } else {
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = this.mensaje2

          this.popupAlert.option = ''
        }
        break
      case 'chat':
        window.open(this.links.WhatsApp, '_blank')
        break
      case 'cda':
        window.open(this.links.CentroDeAyuda, '_blank')
        break
      case 'comodin':
        if (!Functionalities.isAvailable(Functionalities.vida.VICCM, self.functionsRules, self)) {
          return
        }
        auxSolicitud = this.solicitudComodin.pop()

        if (this.puedeCuotaComodin) {
          if (!auxSolicitud || auxSolicitud.state === 'ERROR' || auxSolicitud.state === 'ATENDIDO' ||
              auxSolicitud.state === 'PROCESADO' || auxSolicitud.state === 'PROCESADO RPA' ||
              auxSolicitud.state === 'CONFORME' || auxSolicitud.state === 'RECHAZADO') {
            // this.dialogEndorsementRelease = true
            this.popupAlert.message = this.mensaje1 + 'Cuota comodín...'
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.option = 'comodin'
          }
          if (auxSolicitud && auxSolicitud.state === 'PENDIENTE') {
            this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
            this.popupAlert.message = 'Podrás usar cuota comodín luego de que tu solicitud sea aprobada.'
          }
        } else {
          this.popupAlert.openPopup = true
          this.popupAlert.messageButton = 'Entendido'
          this.popupAlert.buttonClose = this.puedeCuotaComodin
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = this.mensaje2

          this.popupAlert.option = ''
        }
        break
      case 'liberacion':
        if (!Functionalities.isAvailable(Functionalities.vida.VILE, self.functionsRules, self)) {
          return
        }
        auxSolicitud = this.solicitudLiberacionEndoso.pop()

        if (this.puedeCuotaComodin) {
          if (!auxSolicitud || auxSolicitud.state === 'ERROR' || auxSolicitud.state === 'ATENDIDO' ||
              auxSolicitud.state === 'PROCESADO' || auxSolicitud.state === 'PROCESADO RPA' ||
              auxSolicitud.state === 'CONFORME' || auxSolicitud.state === 'RECHAZADO') {
            // this.dialogEndorsementRelease = true
            this.popupAlert.message = this.mensaje1 + 'Liberación de endoso...'
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.option = 'comodin'
          }
          if (auxSolicitud && auxSolicitud.state === 'PENDIENTE') {
            this.popupAlert.title = '¡Estamos atendiendo tu solicitud!'
            this.popupAlert.message = 'Podrás usar cuota comodín luego de que tu solicitud sea aprobada.'
          }
        } else {
          this.popupAlert.openPopup = true
          this.popupAlert.messageButton = 'Entendido'
          this.popupAlert.buttonClose = this.puedeCuotaComodin
          this.popupAlert.title = 'Estimado cliente'
          this.popupAlert.message = this.mensaje2

          this.popupAlert.option = ''
        }
        break
      default:
        break
      }
    },
    actionPopupMethod (action, option) {
      if (option === 'beneficiarios' && action) {
        this.loader.flag = true
        this.loader.text = 'Vamos a Modificación de Beneficiarios...'

        this.$router.push({ name: 'PerfilBeneficiarios',
          params: {
            policy: this.poliza.numeroPoliza,
            productName: this.poliza.producto,
            producto: this.poliza.ramo,
            subProducto: this.poliza.nombreProducto
          }
        })
          .then(data => {
            this.loader.flag = false
            this.popupAlert.openPopup = false
          }).catch(() => {
            this.popupAlert.openPopup = true
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.message = 'No hemos logrado ir a Modificación de Beneficiarios. Por favor, volver a intentarlo en unos minutos o comunicarse con nuestro Servicio de Atención al Cliente.'
            this.popupAlert.messageButton = 'Entendido'
            this.popupAlert.option = ''
            this.popupAlert.buttonClose = false
            this.loader.flag = false
          })
      } else if (option === 'endoso' && action) {
        this.loader.flag = true
        this.loader.text = 'Endoso a entidad financiera...'
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VIEEF', seguroPolicy: this.poliza.numeroPoliza } })
      } else if (option === 'comodin' && action) {
        this.loader.flag = true
        this.loader.text = 'Cuota comodín...'
        this.dialogEndorsementRelease = false
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VICCM', seguroPolicy: this.poliza.numeroPoliza } })
      } else if (option === 'liberacion' && action) {
        this.loader.flag = true
        this.loader.text = 'Liberación de endoso...'
        this.$router.push({ name: 'Formalities', params: { seguroCodeGTM: 'VILE', seguroPolicy: this.poliza.numeroPoliza } })
      }
      this.popupAlert.openPopup = false
      this.loader.flag = false
    },
    desplegarBloqueadosMethod () {
      this.desplegarBloqueados = !this.desplegarBloqueados
    }
  },
  components: {
    TarjetaBeneficiosDesbloqueado2,
    TarjetaBeneficioBloqueado,
    PopupAlertMessage
  }
}
</script>

<style scoped>
@media screen and (min-width:1024px) {

  #btn-endorsements {
    color: #FFF;
    height: 40px;
    padding: 0 40px;
    border-radius: 5px;
    margin-top: 1em;
    margin-bottom: 1em;
    box-shadow: none;
  }

  #btn-endorsements .v-btn__content {
    text-transform: initial;
  }

  .box-beneficios-desbloqueados-formatter {
    padding: 0 .5em;
    margin-left: auto !important;
    margin-right: auto !important;
    max-height: 35rem;
    overflow-y: auto;
  }

  .box-beneficios-desbloqueados-formatter .box-desplegar .bloqueado {
    transition: 0.3s;
    transform: rotate(0deg);
  }

  .box-beneficios-desbloqueados-formatter .box-desplegar .desplegado {
    transform: rotate(180deg);
    transition: 0.3s;
  }
}
@media screen and (min-width:1024px) {
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/BeneficiosDesbloqueados.vue